module.exports = __webpack_public_path__ + "img/portail réaliser dans nos atelier pret a etre posé.55db011e.jpg";